import { Dropdown } from "@lockerpm/design";
import { FormFieldWrapper } from "../helpers/FieldWrapper";
import { ChevronDown } from "@untitled-ui/icons-react";
import { ReactNode } from "react";
import { DropdownItemRenderV2 } from "#src/commonV2/antdHelpers/DropdownItemRender";
import { DropdownRenderV2 } from "#src/commonV2/antdHelpers/DropdownRender";
import { IFormCoreDropdownProps } from "../types";
import { twMerge } from "tailwind-merge";

export interface IFormDropdownProps extends IFormCoreDropdownProps {
  id?: string;
  label: string;
  requiredMark?: boolean;
  hint?: ReactNode;
  tooltip?: ReactNode;
}

export const FormDropdown = (props: IFormDropdownProps) => {
  const syncWidthId = "dropdown-button-" + props.id;

  return (
    <FormFieldWrapper
      label={props.label}
      requiredMark={props.requiredMark}
      error={null}
      hint={props.hint}
    >
      <Dropdown
        menu={{
          items: props.options.map((item) => ({
            key: item.key,
            label: (
              <DropdownItemRenderV2
                label={
                  <>
                    {item.leftIcon ? item.leftIcon : null}
                    {item.getLabel()}
                  </>
                }
                isSelected={item.key === props.selected.key}
              />
            ),
          })),
          onClick: ({ key }) => {
            const selected = props.options.find((item) => item.key === key);
            if (selected) {
              props.onChangeSelected(selected);
            }
          },
        }}
        dropdownRender={(menu) => (
          <DropdownRenderV2 syncWidthId={syncWidthId}>{menu}</DropdownRenderV2>
        )}
        trigger={["click"]}
        disabled={props.disabled}
      >
        <button
          className={twMerge(
            "flex items-center justify-between px-3 py-2 gap-2 flex-1 rounded-lg shadow-xs text-md font-medium text-left",
            "transition-all border outline outline-1 outline-transparent",
            props.disabled
              ? "border-gray-v2-300 bg-gray-v2-50 text-gray-v2 cursor-text"
              : "border-gray-v2-300 cursor-pointer focus-within:border-brand-v2 focus-within:outline-brand-v2"
          )}
        >
          {props.selected ? props.selected.getLabel() : <span />}
          <ChevronDown className="h-5 w-5 min-w-5 text-gray-v2" />
        </button>
      </Dropdown>
    </FormFieldWrapper>
  );
};
